import Storage from 'scr/utilitiesStorage';

export default class DoAction {
    constructor() {
        // group undo/redo
        this.group = undefined; // flag : signle(undefined), groupBegin(true), groupEnd(false)
    }
    get isSingle() {
        return this.group===undefined;
    }
    get isGroupBegin() {
        return this.group !== undefined && this.group;
    }
    get isGroupEnd() {
        return this.group !== undefined && !this.group;
    }
    undo() {
    }
    redo() {
    }

    get viewer() {
        return Storage.get('viewer');
    }
    get scene() {
        this.viewer.scene;
    }
    get selectedObject() {
        return Storage.get('selectedObject');
    }
}